import { Box, FlexBox } from '../../box';
import { ButtonBase, IconButton } from '../../button';
import { Link } from '../../link';
import { styled } from '../../styled';
export const ShellRoot = styled(FlexBox)(({ theme }) => ({
    height: '100%',
    minHeight: 0,
    overflow: 'hidden',
    backgroundColor: theme.palette.background.default,
    '@media (prefers-reduced-motion: reduce)': {
        '& *, & *::before, & *::after': {
            transition: 'none !important',
            animation: 'none !important'
        }
    }
}));
export const ShellWorkspace = styled(FlexBox)(({ theme }) => ({
    flex: 1,
    minWidth: 0,
    minHeight: 0,
    overflow: 'hidden',
    backgroundColor: theme.palette.background.paper,
    borderTopLeftRadius: theme.shape._components?.['subnav-corner'] ??
        Number(theme.shape.borderRadius) * 2
}));
export const ShellSection = styled(FlexBox)(({ theme }) => ({
    width: 250,
    flexShrink: 0,
    minHeight: 0,
    borderRight: `1px solid ${theme.palette.divider}`
}));
export const ShellRail = styled(FlexBox)(({ theme, $collapsed }) => ({
    width: $collapsed ? 70 : 250,
    flexShrink: 0,
    minHeight: 0,
    transition: theme.transitions.create('width', {
        duration: theme.transitions.duration.shorter,
        easing: theme.transitions.easing.easeOut
    })
}));
export const ShellLogoSlot = styled(FlexBox)(({ theme, $collapsed }) => ({
    width: `calc(${$collapsed ? 70 : 250}px - ${theme.spacing(2)})`,
    flexShrink: 0,
    height: 36,
    position: 'relative',
    overflow: 'hidden',
    '& > a': { display: 'block', width: '100%', height: '100%' },
    transition: theme.transitions.create('width', {
        duration: theme.transitions.duration.shorter,
        easing: theme.transitions.easing.easeOut
    })
}));
export const ShellLogoLayer = styled(Box)(({ theme, $visible }) => ({
    position: 'absolute',
    inset: 0,
    display: 'flex',
    alignItems: 'center',
    opacity: $visible ? 1 : 0,
    pointerEvents: $visible ? 'auto' : 'none',
    '& img': { height: 36, maxWidth: '100%' },
    transition: theme.transitions.create('opacity', {
        duration: theme.transitions.duration.shorter
    })
}));
export const ShellToggle = styled(IconButton)(({ theme, $collapsed }) => ({
    flexShrink: 0,
    transform: $collapsed ? 'scaleX(-1)' : undefined,
    transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.shorter
    })
}));
export const ShellNavigationItems = styled(FlexBox)({
    overflowY: 'auto',
    scrollbarGutter: 'stable',
    minHeight: 0
});
export const ShellSearchButton = styled(ButtonBase)(({ theme }) => ({
    width: '100%',
    height: 36,
    padding: theme.spacing(1),
    borderRadius: theme.shape.borderRadius,
    backgroundColor: theme.palette.background.paper,
    '&:focus-visible': {
        outline: `2px solid ${theme.palette.primary.main}`,
        outlineOffset: 2
    }
}));
export const ShellShortcut = styled(FlexBox)(({ theme }) => ({
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: Number(theme.shape.borderRadius) / 2,
    padding: theme.spacing(0, 0.75),
    height: 24,
    flexShrink: 0
}));
export const ShellSkipLink = styled(Link)(({ theme }) => ({
    position: 'absolute',
    top: theme.spacing(1),
    left: theme.spacing(2),
    transform: 'translateY(-200%)',
    zIndex: theme.zIndex.tooltip,
    padding: theme.spacing(1, 2),
    backgroundColor: theme.palette.background.paper,
    '&:focus': { transform: 'translateY(0)' }
}));
